var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46106 0.291504H10.5382C10.916 0.291504 11.2437 0.429511 11.5216 0.70752C11.7996 0.985386 11.9376 1.31312 11.9376 1.69092V13.5347C11.9375 14.0392 11.7289 14.4279 11.3097 14.7036C10.8903 14.9794 10.4489 15.0175 9.98352 14.8169L6.00989 13.1167L6.00012 13.1118L5.99036 13.1167L2.01672 14.8169C1.55134 15.0175 1.11117 14.9792 0.693481 14.7036C0.275818 14.4279 0.0676232 14.0393 0.0675049 13.5347V1.69092C0.0675049 1.31308 0.205499 0.985385 0.482544 0.70752C0.759302 0.429761 1.08494 0.291609 1.46106 0.291504ZM1.43665 13.5718L1.47083 13.5571L5.99915 11.6479L10.5284 13.5571L10.5636 13.5718V1.66553H1.43665V13.5718Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/SaveIcon.291a6fa399042f06c08014b0eb504422.svg";
export { ForwardRef as ReactComponent };